export default __webpack_public_path__ + "static/media/spaceShipE1.bb0eb5ba.webp";